import React, { Component } from 'react';

export default class NotStudent extends Component {
    render() {
        document.body.classList.add("pace-done");
        return (
            <section>
                <h1>This user is not a Student.</h1>
            </section>
        );
    }
}
